import { defineBvaiConfig } from '@bvai/config/config';

import { initAiApiEndpoints } from '@/utilities/api/ai/init';

const AI_CONFIG: BvaiConfig = {
  agent: {
    include_fields: ['conversation.voice', 'conversation.language', 'conversation.greeting_message'],
    actions: ['end_call', 'transfer_call'],
    custom_tools: ['api_request'],
  },
};

/**
 * Initialize the AI configuration and API endpoints
 * This function should be called in the main.js file to initialize the AI configuration and API endpoints
 * @Note this should before calling createBv to initialize the AI configuration and API endpoints
 * @returns void
 */
export const initAiConfig = (): void => {
  defineBvaiConfig(AI_CONFIG);

  // local API endpoints
  initAiApiEndpoints();
};
